module.exports = __webpack_public_path__ + "img/hearts.7e22029.jpg";